import * as AllReducers from './reducers';
import { AppState, Dispatch, Reducer as IReducer } from './types';

const ReducerList = Object.keys(AllReducers).map<IReducer<unknown>>(
  (key: keyof typeof AllReducers) => AllReducers[key],
);

export const Reducer = (state: AppState, action: Dispatch) =>
  ReducerList.reduce((prev, next) => ({ ...prev, [next.key]: next(state[next.key], action) }), {} as AppState);

export const initialState = ReducerList.reduce(
  (prev, next) => ({ ...prev, [next.key]: next.initialState }),
  {} as AppState,
);
